import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {Platform} from 'react-native';
import FastImage from 'react-native-fast-image';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
`;

export const ContentHeader = styled.View`
  padding: 0 24px;
  margin-bottom: ${RFValue(10)}px;
`;

export const PlacaListTitlesContainer = styled.View`
  padding: 0 24px;
  margin: ${RFValue(12)}px 0;
`;

export const Title = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
`;

export const Subtitle = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
`;

export const ContentBanners = styled.View`
  height: ${RFValue(50)}px;
`;

export const CustomPanel = styled.TouchableOpacity`
  margin: 0 24px;
  border-radius: ${RFValue(12)}px;
`;

//@ts-ignore
export const PanelImage = styled(FastImage)`
  width: 100%;
  height: ${RFValue(50)}px;
  border-radius: ${RFValue(12)}px;
`;

export const PlacaList = styled.ScrollView``;

export const Footer = styled.View`
  padding: 0 24px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? getBottomSpace()
    : RFValue(20)}px;
`;
